import AsyncStorage from '@react-native-async-storage/async-storage';
import React, { useCallback, useEffect, useRef, useState } from 'react';
import { ActivityIndicator, Alert, Image, Text, TouchableOpacity, View } from 'react-native';
//import Carousel, { Pagination } from 'react-native-snap-carousel';
import { FontAwesome } from "@expo/vector-icons";
import { LinearGradient } from "expo-linear-gradient";

import paymentService from '../../services/paymentService';

import { styles } from './styles';
import toast from '../../utils/toast';

const CreditCardList = ({ onCardChanged = null, onEmpty = null }) => {
  const [cards, setCards] = useState([]);
  const [isLoading, setIsLoading] = useState(true);

  const [activeIndex, setActiveIndex] = useState(0);

  useEffect(() => {
    async function loadCards() {
      const token = await AsyncStorage.getItem('JWT_TOKEN');
      try {
        const response = await paymentService.getCreditCards(token);
        setCards(response.data);
        if (response.data.length === 0) onEmpty && onEmpty();
        else onCardChanged && onCardChanged(response.data[0]);
      } catch (err) {
        toast('Falha ao carregar cartões de crédito.', "#DA1414");
      } finally {
        setIsLoading(false);
      }
    }
    loadCards();
  }, []);

  useEffect(() => {
    onCardChanged && onCardChanged(cards[activeIndex]);
  }, [activeIndex]);

  function onDeleteCardPressed(card) {
    Alert.alert('Excluir cartão', 'Deseja mesmo remover este cartão?',
      [
        {
          text: 'Não',
          onPress: () => { }
        },
        {
          text: 'Sim',
          onPress: () => deleteCard(card)
        },
      ]);
  }

  const ref = useRef(null);

  async function deleteCard(card) {
    const token = await AsyncStorage.getItem('JWT_TOKEN');
    console.log('Deleting card', card.id);
    console.log('Cards', cards);
    try {
      await paymentService.deleteCreditCard(token, card.id);
      setCards((cards) => cards.filter((x) => x.id !== card.id));
    } catch (err) {
      console.log(err);
      toast('Falha remover cartão.', "#DA1414");
    } finally {
      setIsLoading(false);
    }
  }

  useEffect(() => {
    if (!isLoading)
      ref.current.snapToItem(0);
  }, [cards]);

  const renderItem = useCallback(({ item, index }) => {
    return (
      <LinearGradient
        start={{ x: -1, y: 0 }}
        end={{ x: 1, y: 0 }}
        colors={["#16195B", "#1FBFB5"]}
        style={styles.contentCard}
      >
        <TouchableOpacity
          style={styles.deleteIcon}
          onPress={() => onDeleteCardPressed(item)}
        >
          <FontAwesome name="trash" size={24} color="#FFF" />
        </TouchableOpacity>

        <Image
          source={require("../../../assets/icon_coin.png")}
          style={styles.img_coin}
        />

        <Text style={styles.number}>{item.number}</Text>
        <Text style={styles.brand}>{item.brand}</Text>

        <Image
          source={require("../../../assets/masterCard.png")}
          style={styles.imgBank}
        />
      </LinearGradient>
    );
  }, []);


  if (isLoading) {
    return <ActivityIndicator color="#1FBFB5" size="large" style={{ marginTop: 10 }} />
  }

  return (
    <View style={styles.container}>
      {cards.map(item=> renderItem(item))}
      {/* <Carousel
        ref={ref}
        layout={"default"}
        data={cards}
        sliderWidth={400}
        itemWidth={350}
        renderItem={renderItem}
        onSnapToItem={(index) => setActiveIndex(index)}
      />
      <Pagination
        dotsLength={cards.length}
        activeDotIndex={activeIndex}
        dotStyle={{
          width: 10,
          height: 10,
          borderRadius: 5,
          marginHorizontal: 2,
          backgroundColor: "rgba(44, 44, 46, 1)",
        }}
        inactiveDotOpacity={0.4}
        inactiveDotScale={0.6}
      /> */}
    </View>
  );
}

export default CreditCardList;